import React, { useEffect, useLayoutEffect, useState } from "react";

const Section1 = () => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 425);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 425);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="pt-[160px] sm:pt-0">
      {isDesktop ? (
        <img
          src="/assets/mbg-banner.webp"
          alt=""
          className="h-[200px] w-full sm:h-auto object-fit"
        />
      ) : (
        <img
          src="/assets/mean3xmbg-bannerMob.webp"
          alt=""
          className="h-auto w-full sm:h-auto object-fit"
        />
      )}
    </div>
  );
};

export default Section1;
